import React from "react";
import Button from "@components/Button";
import { useIoCContext } from "@context/IoCContext/IoCContext";
import { useDownloadReport } from "@hooks/useDownloadReport";
import { useMyDriversContext } from "@context/MyDriversContext";
import { IMyDriversService } from "@modules/user/models/IMyDriversService";
import { Types } from "@ioc/types";
import { useFlags } from "flagsmith/react";
import { Skeleton, useMediaQuery, useTheme } from "@mui/material";

const DownloadButton: React.FC = () => {
  const { serviceContainer } = useIoCContext();
  const { download, icon, loading: loadingDownload } = useDownloadReport();
  const { enabled } = useFlags([
    "user_my_drivers_download_report_button",
  ]).user_my_drivers_download_report_button;
  const {
    loading,
    filters: { driverQuery, companyDocuments },
  } = useMyDriversContext();

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const myDriversService = serviceContainer.get<IMyDriversService>(
    Types.Users.IMyDriverService
  );

  const report = (): Promise<Blob> =>
    myDriversService.downloadReport(driverQuery, companyDocuments);

  if (!enabled) return null;

  return loading ? (
    <Skeleton animation="wave" height="5rem" width="10rem" />
  ) : (
    <Button
      variant="contained"
      fullWidth={isMobile}
      disabled={loadingDownload}
      startIcon={icon}
      onClick={() => download(report)}
      sx={{ minHeight: "44px" }}
    >
      Baixar relatório
    </Button>
  );
};

export { DownloadButton };
